<template>
  <div>
    <el-dialog class="dia" :visible.sync="_show" top="30vh" width="48rem" destroy-on-close :close-on-click-modal="false">
      <div class="flex justify-between -mx-20px -mt-60px -mb-10px">
        <img class="w-17rem <lg:hidden -mb-20px container"
          src="https://cdn-qn.huaeb.com/sellmall/20210831/FnOqcUBTUUUg7tT7NpBLOuaNi0PU.png" alt="" />
        <div class="mt-12 mx-16 w-full">
          <component :is="curType.component" v-on="$listeners"></component>
          <div class="flex justify-end items-center  text-lg pt-4">
            <el-link type="warning" @click="changeType">{{ curType.key == 'login' ? $t('去注册') : $t('去登录') }}<span
                class="iconfont icon-right "></span></el-link>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  computed,
  defineAsyncComponent,
  reactive,
  ref,
  watchEffect
} from "@vue/composition-api";
import { defineComponent } from "@vue/runtime-dom";
const SignIn = defineAsyncComponent(() =>
  import("@/components/base/signIn.vue")
);
const SignUp = defineAsyncComponent(() =>
  import("@/components/base/signUp.vue")
);

export default defineComponent({
  props: { show: Boolean,type:String },
  setup(props, ctx) {
    const _show = computed({
      get: () => props.show,
      set: (val) => {
        ctx.emit("update:show", val);
      },
    });
    const types = reactive([
      {
        key: 'login',
        name: ctx.root.$t("登录"),
        component: SignIn,
      },
      {
        key: 'register',
        name: ctx.root.$t("注册"),
        component: SignUp,
      },
    ])
    const curType = ref(types[0])
    // const currentTab = ref(tabs[0]);
    const changeType = () => {
      curType.value = curType.value.key == 'login' ? types[1] : types[0]
    }
    watchEffect(() => {
      if (props.type == 'login') {
        curType.value = types[0]
      } else if (props.type == 'register') {
        curType.value = types[1]
      }
    })
    return { _show, curType, changeType, types,  };
  },
});
</script>

<style scoped lang="scss">.tab {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  cursor: pointer;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-bottom: 0.5rem;
  white-space: nowrap;
  width: 32px;
}
.hover:hover {
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
  border-bottom-width: 2px;
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
.active {
  --tw-border-opacity: 1;
  border-color: rgba(21, 186, 99, var(--tw-border-opacity));
  border-bottom-width: 2px;
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
}</style>
